import { Tc, PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from "../../../core/_infrastructure/types/common";


export class TipoBultoItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: TipoBultoViewModel[];
}
export class TipoBultoViewModel {

    constructor() {

    }

    public Id: number;
    public Descripcion: string = '';
    public DescripcionIngles: string = '';
    public Codigo: string = '';
    public Habilitado: boolean = true;
}


export class FilterSearchingTipoBultoViewModel extends FilterSearchingBaseViewModel {
     
    public Descripcion: string = '';
    public DescripcionIngles: string = '';
    public Codigo: string = '';
    public Habilitado: number = EnumSiNoTodos.TODOS;
}







